import { Component, input, output } from '@angular/core';
import { RouterLink, RouterLinkActive } from '@angular/router';
import { NavigationItem } from './models/navigation-item.model';
import { TranslatePipe } from '@ngx-translate/core';
import { NgClass } from '@angular/common';
import { NgbTooltip } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'adf-navigation-tree',
  imports: [RouterLink, RouterLinkActive, TranslatePipe, NgClass, NgbTooltip],
  templateUrl: './navigation-tree.component.html',
  styleUrl: './navigation-tree.component.scss',
})
export class NavigationTreeComponent {
  navigationItems = input.required<NavigationItem[]>();
  iconOnly = input(false);
  action = output<string>();
}
